import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isArray, isEmpty } from 'lodash';
import './Textarea.scss';

class Textarea extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.props.onChange(e);
  }

  render() {
    const {
      label,
      name,
      className,
      value,
      maxLength,
      placeholder,
      disabled,
      required,
      error,
      optionalText,
      rows,
      clearValue,
      labelInfo,
      isValueChanged,
      containerClassName,
    } = this.props;

    const textError = error && isArray(error) ? error[0] : error;
    const noSubText = !textError && !optionalText && !maxLength;
    const width = window.innerWidth;
    const isMobile = width < 767;
    return (
      <div className={`textarea-container ${textError ? 'error' : ''} ${containerClassName}`}>
        {label && (
          <label
            htmlFor={name}
            className={`w-100 ${isValueChanged ? 'value-changed' : ''} ${
              textError ? 'label-error' : ''
            }`}>
            {this.props.t(label)}
            {labelInfo && <span className="fw-normal"> ({labelInfo})</span>}
          </label>
        )}
        <div className={clearValue && !isEmpty(value) ? 'group-btn-inside' : ''}>
          <textarea
            className={className}
            value={value}
            name={name}
            id={name}
            rows={rows}
            onChange={this.handleChange}
            maxLength={maxLength}
            placeholder={placeholder}
            disabled={disabled}
            required={required}
          />
          {clearValue && !isEmpty(value) && (
            <button className="btn-link btn-inside" onClick={clearValue}>
              {this.props.t('common.labels.clear')}
            </button>
          )}
        </div>
        {!noSubText && (
          <div className="footer-section">
            <div className={`d-inline-block ${isMobile ? 'w-50' : 'w-75'} text-start font-size-12`}>
              {textError && <span className="text-error">{this.props.t(textError)}</span>}
              {optionalText && !textError && (
                <span className="optional-field">{this.props.t(optionalText)}</span>
              )}
            </div>
            {!!maxLength && (
              <span className={`text-end float-end ${isMobile ? 'w-50' : 'w-25'} font-size-12`}>
                {this.props.t('testCenter.dateMessages.lengthLabel', {
                  current: value.length,
                  max: maxLength,
                })}
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
}

Textarea.propTypes = {
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  required: PropTypes.bool,
  label: PropTypes.string,
  optionalText: PropTypes.string,
  rows: PropTypes.number,
  clearValue: PropTypes.func,
  labelInfo: PropTypes.string,
  isValueChanged: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

Textarea.defaultProps = {
  disabled: false,
  className: '',
  placeholder: '',
  required: false,
  value: '',
  clearValue: null,
  labelInfo: '',
  isValueChanged: false,
  containerClassName: '',
};

export default withTranslation()(Textarea);
